export default __webpack_public_path__ + "870ec35fb5456193272275a5215c2c1a.png";